// An unsafe href is dropped rather than neutralized, so a dead CTA never reaches the viewer.
const SAFE_PROTOCOLS = new Set(['http:', 'https:'])

/** The href when it is safe to render in an anchor, otherwise undefined. */
export function safeHref(href: string): string | undefined {
  let protocol: string
  try {
    // A base lets relative hrefs parse and inherit a safe scheme; a malformed href throws.
    protocol = new URL(href, '/').protocol
  } catch {
    return undefined
  }
  return SAFE_PROTOCOLS.has(protocol) ? href : undefined
}
